import { useCallback, useRef } from 'react';
import avo from 'analytics/avo';
import usePDPGalleryProductProperties from './usePDPGalleryProductProperties';
import { GALLERY_IMAGE_LOCATION } from './pdpGalleryEventConstants';
const usePDPViewGalleryImageEvent = () => {
  const productProperties = usePDPGalleryProductProperties();
  const productPropertiesRef = useRef(productProperties);
  productPropertiesRef.current = productProperties;

  // A ref, not state: scroll handlers can call twice before React re-renders,
  // and a queued state update would let the second call through
  const lastImageRef = useRef(null);

  // The hook lives at page level, so it outlives any one gallery opening. Each
  // opening has to start clean or the first image repeated from last time is
  // silently dropped.
  const resetGalleryImageTracking = useCallback(() => {
    lastImageRef.current = null;
  }, []);
  const viewGalleryImageEvent = useCallback(({
    imageLocation,
    imageFilename,
    position
  }) => {
    // The configuration strip reports through here too, but the event covers
    // the Lifestyle Gallery only
    if (imageLocation !== GALLERY_IMAGE_LOCATION.LIFESTYLE) {
      return;
    }
    const curImg = `${imageLocation}:${position}`;
    if (lastImageRef.current === curImg) return;
    lastImageRef.current = curImg;
    const properties = productPropertiesRef.current;
    avo.pdpGalleryImageViewed({
      category: properties.category,
      productFamily: properties.productFamily,
      productId: properties.productId,
      name: properties.name,
      variant: properties.variant,
      sku: properties.sku,
      price: properties.price,
      // Gallery state is 0-based, the Avo property is 1-based
      imageIndex: position + 1,
      // Lifestyle photos have no asset id - usePDPPhotos sets each photo's
      // `id` to its own URL - so the filename is the best identifier we have
      imageId: imageFilename
    });
  }, []);
  return {
    resetGalleryImageTracking,
    viewGalleryImageEvent
  };
};
export default usePDPViewGalleryImageEvent;